import { mswEnabled } from '../mocks/toggles'

/**
 * Base URL for the patients-facing API (scheduling, medical history, etc.).
 * Uses REACT_APP_PATIENTS_API_BASE_URL when set.
 * Falls back to REACT_APP_MSW_BASE_URL only while MSW is active (?msw=on).
 */
export const getPatientsApiBaseUrl = () => {
  const patientsUrl = process.env.REACT_APP_PATIENTS_API_BASE_URL
  if (patientsUrl) {
    return patientsUrl.replace(/\/$/, '')
  }

  if (typeof window !== 'undefined' && mswEnabled()) {
    const mswUrl = process.env.REACT_APP_MSW_BASE_URL
    return mswUrl ? mswUrl.replace(/\/$/, '') : ''
  }

  return ''
}

export const buildPatientsApiUrl = (path) => {
  const base = getPatientsApiBaseUrl()
  if (!base) return null
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${base}${normalizedPath}`
}
